import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { paths } from '@app/constants/paths';
import { PagesComponent } from '@app/pages/pages.component';
import { SignInComponent } from '@app/pages/sign-in/sign-in.component';
import { AuthGuard, AxiomGuard, MaintenanceModeGuard  } from '@app/core/guards';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AxiomPageComponent } from '@app/shared/components/axiom-page/axiom-page.component';
import { SupportComponent } from './support/support.component';
import { HealthComponent } from './health/health.component';
import { OverviewComponent } from './overview/overview.component';
import { VersionComponent } from './version/version.component';
import { HowToGuideComponent } from './how-to-guide/how-to-guide.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: paths.HOME,
    component: PagesComponent,
    children: [
      {
        path: paths.CHARTS_MANAGER,
        loadChildren: () => import('./charts-manager/charts-manager.module').then(m => m.ChartsManagerModule),
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'CHARTS_MANAGER' }
      },
      {
        path: paths.OVERVIEW,
        component: OverviewComponent,
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'OVERVIEW' }
      },
      {
        path: paths.HOW_TO_GUIDE,
        component: HowToGuideComponent,
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'HOW_TO_GUIDE' }
      },
      {
        path: paths.LIGHT_HOUSE_CHART,
        loadChildren: () => import('./charts-store/charts-store.module').then(m => m.ChartsStoreModule),
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'CHARTS_STORE' }
      },
      {
        path: paths.PAYMENT,
        loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule),
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'PAYMENT' }
      },
      {
        path: paths.SIGN_IN,
        component: SignInComponent,
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'SIGN_IN' }
      },
      {
        path: paths.AXIOM_PAGE,
        component: AxiomPageComponent
      },
      {
        path: paths.PAGE_NOT_FOUND,
        component: PageNotFoundComponent,
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'PAGE_NOT_FOUND' }
      },
      {
        path: paths.SUPPORT,
        component: SupportComponent,
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'SUPPORT' }
      },
      {
        path: paths.HEALTH,
        component: HealthComponent,
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'HEALTH' }
      },
      {
        path: paths.VERSION,
        component: VersionComponent,
        canActivate: [MaintenanceModeGuard, AxiomGuard],
        data: { component: 'VERSION' }
      },
      // This is an abnormal case for task https://jiracommercial.flir.com/browse/FMCAR-5422
      {
        path: `${paths.CHARTS_MANAGER}/${paths.DOWNLOAD_RAYCONNECT}`,
        loadChildren: () => import('./charts-manager/download-rayconnect/download-rayconnect.module').then(m => m.DownloadRayconnectModule),
      },
      {
        path: paths.DOWNLOAD_RAYCONNECT,
        loadChildren: () => import('./charts-manager/download-rayconnect/download-rayconnect.module').then(m => m.DownloadRayconnectModule),
      },
      {
        path: paths.MY_ACCOUNT,
        canActivate: [MaintenanceModeGuard, MsalGuard],
        loadChildren: () => import('./my-account/my-account.module').then(m => m.MyAccountModule),
      },
      {
        path: paths.MOBILE,
        redirectTo: paths.DOWNLOAD_RAYCONNECT
      },
      {
        path: paths.HOME,
        redirectTo: paths.OVERVIEW
      },
      {
        path: '**',
        redirectTo: paths.PAGE_NOT_FOUND
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
